import { Layout, Button, Space, Dropdown, Avatar, Typography, Badge, Popover } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BulbOutlined,
  BgColorsOutlined,
  BellOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { useSettingsStore, COLOR_THEMES } from '@store/settingsStore';
import { useAuth } from '@hooks/useAuth';
import { useNotificationStore } from '@store/notificationStore';
import { useNavigate } from 'react-router-dom';
import { NotificationCenter } from './NotificationCenter';
import { Breadcrumbs } from './Breadcrumbs';
import { ROUTES } from '@app/router/routes';

export function TopNav() {
  const { user, logout } = useAuth();
  const collapsed = useSettingsStore((s) => s.sidebarCollapsed);
  const setCollapsed = useSettingsStore((s) => s.setSidebarCollapsed);
  const toggleTheme = useSettingsStore((s) => s.toggleTheme);
  const theme = useSettingsStore((s) => s.theme);
  const colorTheme = useSettingsStore((s) => s.colorTheme);
  const setColorTheme = useSettingsStore((s) => s.setColorTheme);
  const unread = useNotificationStore((s) => s.unreadCount);
  const navigate = useNavigate();

  return (
    <Layout.Header
      style={{
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        borderBottom: theme === 'dark' ? '1px solid rgba(255,255,255,0.06)' : '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
      />
      <Breadcrumbs />
      <div style={{ flex: 1 }} />
      <Space size={8}>
        <Dropdown
          menu={{
            items: COLOR_THEMES.map((t) => ({
              key: t.key,
              label: (
                <Space>
                  <span
                    style={{
                      display: 'inline-block',
                      width: 12,
                      height: 14,
                      borderRadius: '4px',
                      backgroundColor: t.color,
                      border: theme === 'dark' ? '1px solid rgba(255,255,255,0.15)' : '1px solid rgba(0,0,0,0.1)',
                    }}
                  />
                  <span style={{ fontWeight: colorTheme === t.key ? 'bold' : 'normal' }}>{t.label}</span>
                </Space>
              ),
              onClick: () => setColorTheme(t.key),
            })),
            selectable: true,
            selectedKeys: [colorTheme],
          }}
          trigger={['click']}
          placement="bottomRight"
        >
          <Button
            type="text"
            icon={<BgColorsOutlined style={{ color: COLOR_THEMES.find(t => t.key === colorTheme)?.color }} />}
            title="Change Accent Color Theme"
          />
        </Dropdown>
        <Button
          type="text"
          icon={<BulbOutlined />}
          onClick={toggleTheme}
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'}`}
        />
        <Popover content={<NotificationCenter />} trigger="click" placement="bottomRight">
          <Badge count={unread} size="small">
            <Button type="text" icon={<BellOutlined />} />
          </Badge>
        </Popover>
        <Dropdown
          menu={{
            items: [
              {
                key: 'profile',
                label: 'Profile',
                icon: <UserOutlined />,
                onClick: () => navigate(ROUTES.profile),
              },
              {
                key: 'settings',
                label: 'Settings',
                icon: <SettingOutlined />,
                onClick: () => navigate(ROUTES.settings),
              },
              { type: 'divider' },
              {
                key: 'logout',
                label: 'Logout',
                icon: <LogoutOutlined />,
                danger: true,
                onClick: () => void logout(),
              },
            ],
          }}
        >
          <Space style={{ cursor: 'pointer' }}>
            <Avatar icon={<UserOutlined />} src={user?.avatarUrl || undefined} />
            <Typography.Text>{user?.fullName ?? 'Guest'}</Typography.Text>
          </Space>
        </Dropdown>
      </Space>
    </Layout.Header>
  );
}
